import SettingsSummaryCard, { SettingDetail } from '../settings-summary-card/SettingsSummaryCard';
import { useTranslation } from 'react-i18next';
import { ReactElement, useMemo } from 'react';
import { mapProvidersWithUrl, useGetUiSettingsQuery } from '@casops/store/apis/settingsApi';
import { SettingsSidePanelTab } from '@casops/store/slices/globalSlice';
import { MapProviderType } from '@cas/types/settings';

export const MapSettings = (): ReactElement => {
  const { t } = useTranslation();

  const { currentData: uiSettings } = useGetUiSettingsQuery();

  const settings = useMemo<SettingDetail[]>(() => {
    let providerType: MapProviderType | undefined;
    let uri: null | string | undefined;

    // Destructure and assign the query result.
    if (uiSettings) {
      ({
        map: { providerType, uri },
      } = uiSettings);
    }

    // Create the settings that are always displayed.
    const settings: SettingDetail[] = [
      [t('Fields.MapProvider'), providerType ? t(`MapProviderType.${providerType}`) : undefined],
    ];

    // Optionally show the URL if the provider type is one that requires it.
    if (providerType && mapProvidersWithUrl.includes(providerType)) {
      settings.push([t('Fields.Url'), typeof uri === 'string' ? uri : undefined]);
    }

    return settings;
  }, [t, uiSettings]);

  return (
    <SettingsSummaryCard
      title={t('Navigation.Map')}
      settings={settings}
      sidePanelTab={SettingsSidePanelTab.Map}
    />
  );
};

export default MapSettings;
